import { render } from "./report.vue?vue&type=template&id=4baf72d8&ts=true"
import script from "./report.vue?vue&type=script&lang=ts"
export * from "./report.vue?vue&type=script&lang=ts"

import "./report.vue?vue&type=style&index=0&id=4baf72d8&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__